<template>
  <div>
    <div class="privot" :class="privotClass" :style="[privotStyle]" v-if="privotText && privotPos === 'top' && showPrivot">
      <span :style="[progressPrivotOutStyle, {transform: 'translate(-50%, -100%)'}, privotStyle]">{{ privotText }}</span>
    </div>
    <div style="display: flex; align-items: center;">
      <div class="privot" :class="privotClass" style="margin-right: 16px;" v-if="privotText && privotPos === 'left' && showPrivot">
        <span :style="[{ color: privotColor }, privotStyle]">{{ privotText }}</span>
      </div>
      <div class="progress" :style="[progressStyle]">
        <span class="progress__portion" :style="[progressPortionStyle]"/>
        <span class="progress__pivot" :style="[progressPrivotStyle, privotStyle]" v-if="privotText && ((privotPos || 'center') === 'center') && showPrivot">{{ privotText }}</span>
      </div>
      <div class="privot" :class="privotClass" style="margin-left: 16px;" v-if="privotText && privotPos === 'right' && showPrivot">
        <span :style="[{ color: textColor }, privotStyle]">{{ privotText }}</span>
      </div>
    </div>
    <div class="privot" :class="privotClass" :style="[privotStyle]" v-if="privotText && privotPos === 'bottom' && showPrivot">
      <span :style="[progressPrivotOutStyle, {transform: 'translate(-50%)'}, privotStyle]">{{ privotText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['inactive', 'percentage', 'strokeWidth', 'showPrivot', 'color', 'background',
    'textColor', 'trackColor', 'privotText', 'privotColor', 'privotPos',
    'privotClass', 'privotStyle'],
  computed: {
    progressStyle() {
      let style = {
        flex: 1, 
        background: this.trackColor || this.background || '#e5e5e5', 
        height: this.strokeWidth || '4px',
        borderRadius: this.strokeWidth ? parseInt(this.strokeWidth)/2 + 'px' : '2px',
      }
      return style
    },
    progressPortionStyle() {
      let style = {
        width: (this.percentage || 0) + '%',
      }
      if (this.color) {
        style.background = this.color
      }
      return style
    },
    progressPrivotStyle() {
      let style = {
        left: (this.percentage || 0) + '%',
      }
      if (this.privotColor) {
        style.background = this.privotColor
      }
      if (this.textColor) {
        style.color = this.textColor
      }
      return style
    },
    progressPrivotOutStyle() {
      let style = {
        left: (this.percentage || 0) + '%',
        whiteSpace: 'nowrap', 
        position: 'absolute'
      }
      if (this.privotColor) {
        style.background = this.privotColor
      }
      if (this.textColor) {
        style.color = this.textColor
      }
      return style
    }
  }
}
</script>

<style lang="less" scoped>
.progress {
  position: relative;
  height: 12px;
  border-radius: 9px;

  .progress__portion {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background: #1989fa;
    border-radius: inherit;
    transform-origin: 0;
    transition: all 0.3s ease-out;
  }
  .progress__pivot {
    position: absolute;
    top: 50%;
    box-sizing: border-box;
    min-width: 3.6em;
    padding: 0 5px;
    color: white;
    font-size: 10px;
    line-height: 1.6;
    text-align: center;
    word-break: keep-all;
    background: #1989fa;
    border-radius: 1em;
    transition: all 0.3s ease-out;
  }
}

.privot {
  font-size: 16px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  position: relative;
}
</style>